import { useState } from 'react'
import { Link } from 'react-router-dom'

const INK = "#1a1a2e";
const MUTED = "var(--color-text-primary)";
const TEAL = "var(--color-text-secondary)";
const TEAL_BG = "#eaf3f3";
const BORDER = "#e2e6ea";
const CARD = "#ffffff";

export default function ViewCard({ item }) {
   const { title, text, icon, href } = item
   const [hovered, setHovered] = useState(false)

   return (
      <Link
         to={href}
         style={{ textDecoration: "none", display: "block" }}
         onMouseEnter={() => setHovered(true)}
         onMouseLeave={() => setHovered(false)}
      >
         <div style={{
            background: hovered ? TEAL : CARD,
            border: `1px solid ${hovered ? TEAL : BORDER}`,
            borderRadius: 12,
            padding: "4px",
            transition: "background 0.2s ease, border-color 0.2s ease",
            display: "flex",
            gap: 8,
            height: "100%",
            boxSizing: "border-box",
         }}>

            {/* Ícono */}
            {icon && (
               <div style={{
                  width: 42,
                  height: 42,
                  borderRadius: 10,
                  background: hovered ? "rgba(255,255,255,0.15)" : TEAL_BG,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  color: hovered ? "#ffffff" : TEAL,
                  transition: "background 0.2s ease, color 0.2s ease",
               }}>
                  {icon}
               </div>
            )}

            {/* Texto */}
            <div style={{ display: "flex", flexDirection: "column", gap: 0, flex: 1, overflowX: 'hidden', }}>
               {title && (
                  <span style={{
                     fontSize: 15,
                     fontWeight: 700,
                     color: hovered ? "#ffffff" : INK,
                     lineHeight: 1.3,
                     transition: "color 0.2s ease",
                  }}>
                     {title}
                  </span>
               )}
               {text && (
                  <span style={{
                     fontSize: "var(--fs-tiny)",
                     color: hovered ? "rgba(255,255,255,0.7)" : MUTED,
                     lineHeight: 1.55,
                     transition: "color 0.2s ease",
                     display: "block",
                     overflow: "hidden",
                     whiteSpace: "nowrap",
                     textOverflow: "ellipsis",
                  }}>
                     {text}
                  </span>
               )}
            </div>

            {/* Flecha */}
            <div style={{
               display: "flex",
               justifyContent: "flex-end",
               opacity: hovered ? 1 : 0,
               transform: hovered ? "translateX(0)" : "translateX(-6px)",
               transition: "opacity 0.2s ease, transform 0.2s ease",
            }}>
               <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M3 8h10M9 4l4 4-4 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
               </svg>
            </div>

         </div>
      </Link>
   )
}
